/* eslint-disable react/forbid-prop-types */
import React from "react";
import ButtonGroup from "@mui/material/ButtonGroup";
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import ExperimentalAppBar from "./appBar";
import LanguageSwitcher from "../appDropdown/dropDown";
import { Typography } from "@mui/material";

const AppLogo = require("../../asset/enterprise_search_hub_logo.svg").default;
const AppLogoMobile =
  require("../../asset/enterprise_search_hub_logo_mobile.svg").default;

const LeftButtonGroupStyled = styled(ButtonGroup)(({ theme }) => ({
  justifyContent: "flex-start",
  alignItems: "center",
  padding: "0px",
  cursor: "pointer",

  [theme.breakpoints.up("xs")]: {
    height: "48px",
  },
  [theme.breakpoints.up("sm")]: {
    height: "56px",
  },
  [theme.breakpoints.up("md")]: {
    height: "56px",
  },
  [theme.breakpoints.up("lg")]: {
    height: "56px",
  },
  [theme.breakpoints.up("xl")]: {
    height: "56px",
  },
}));

const AppLogoStyled = styled(Typography)(({ theme }) => ({
  padding: "0px",
  fontSize: "18px",
  fontWeight: 600,
  [theme.breakpoints.up("xs")]: {
    display: "none",
  },
  [theme.breakpoints.up("sm")]: {
    display: "flex",
  },
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
  [theme.breakpoints.up("lg")]: {
    display: "flex",
  },
  [theme.breakpoints.up("xl")]: {
    display: "flex",
  },
}));

const AppLogoStyledMobile = styled(Typography)(({ theme }) => ({
  padding: "0px",
  fontSize: "14px",
  fontWeight: 600,
  [theme.breakpoints.up("xs")]: {
    display: "flex",
  },
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
  [theme.breakpoints.up("lg")]: {
    display: "none",
  },
  [theme.breakpoints.up("xl")]: {
    display: "none",
  },
}));

// Main Function based Component Starts here
export default function AppBarChildren() {
  const navigate = useNavigate();
  const appBarLeftChildren = () => (
    <LeftButtonGroupStyled onClick={() => navigate(0)}>
      <AppLogoStyled>さくっとサーチ</AppLogoStyled>
      <AppLogoStyledMobile>さくっとサーチ </AppLogoStyledMobile>
    </LeftButtonGroupStyled>
  );

  const appBarRightChildren = () => <LanguageSwitcher />;

  return (
    <>
      <ExperimentalAppBar
        leftChildren={appBarLeftChildren()}
        rightChildren={appBarRightChildren()}
      />
    </>
  );
}
